import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';
import Card from '@material-ui/core/Card';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '../Button';

const styles = theme => ({
  root: {
    width: 400,
    minHeight: 250,
    padding: 10,
    display: 'grid',
    gridTemplateColumns: '1fr 5fr 1fr',
  },
  title: {
    gridColumn: '1 / span 3',
  },
  password: {
    gridColumn: '1 / span 3',
    justifySelf: 'center',
  },
  button: {
    gridColumn: '2 / 3',
    // justifySelf: 'center',
  },
});

const ChangePassForm = ({ classes, onForceChangePass: forceChangePass }) => {
  const [showPass, setShowPass] = React.useState(false);
  const [password, setPassword] = React.useState('');

  const handleSignIn = e => {
    e.preventDefault();
    forceChangePass(password);
  };

  return (
    <form onSubmit={handleSignIn}>
      <Card raised className={classes.root}>
        <Typography className={classes.title} variant="headline">
          CHANGE PASSWORD
        </Typography>
        <TextField
          className={classes.password}
          variant="outlined"
          label="Password"
          type={showPass ? 'text' : 'password'}
          value={password}
          onChange={e => setPassword(e.target.value)}
          helperText="You need to change your password on first time sign in."
          InputProps={{
            required: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPass(!showPass)}>
                  {showPass ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button classes={{ root: classes.button }} color="secondary" type="submit">
          Continue signing in
        </Button>
      </Card>
    </form>
  );
};

export default withStyles(styles)(ChangePassForm);
